/*
 * Aero Extension - A/B Testing config (OPTIONAL)
 * ----------------------------------------------
 * Declares tests consumed by aero-extension-ab-test.js (v3). Each entry is passed
 * to ABTestFramework.initTest() automatically on page load (when its `match` passes).
 *
 * Only load this file when you have config-driven tests. If you only use inline
 * (data-ab-section / data-ab-variant) markup tests, you can skip it.
 *
 * Shape:
 *   window.AB_TEST_CONFIG = {
 *     options: { debug: true },        // optional, same keys as script defaults
 *     tests: [ ...testConfig objects... ]   // or set AB_TEST_CONFIG directly to an array
 *   };
 *
 * testConfig object (v3):
 *   {
 *     testId: 'product_cta_v1',        // REQUIRED: cookie key + tracking test_id
 *     testName: 'Product CTA copy',    // optional: reported as test_name
 *     testType: 'classic_ab',          // classic_ab | abn_testing | split_url |
 *                                       //   multivariate | multipage | aa_testing
 *     pageType: 'product',             // optional: reported as page_type
 *     pagePosition: 'step_1',          // optional: reported for multipage tests
 *     sectionId: 'product_cta_v1',     // optional: [data-ab-section] to swap (defaults to testId)
 *     variants: ['A', 'B'],            // variant names (omit to read from inline DOM)
 *     variantWeights: [0.5, 0.5],      // optional: aligned to `variants` (defaults to equal)
 *     match: {                         // optional: where this test runs (all AND-ed)
 *       pageType: 'product',           //   blog_post | page | product | collection | cart
 *       resourceType: 'product',       //   raw Shopify resourceType (article|page|product|collection)
 *       resourceId: 1234567890,        //   exact resource id
 *       urlContains: '/products/foo',  //   substring of location.href
 *       selector: '.product-form'      //   only run if this element exists
 *     }
 *   }
 *
 * Test-type extras:
 *   split_url   -> add  urls: { A: '/path-a', B: '/path-b' }   (redirects to urls[variant])
 *   multivariate-> add  elements: [ { elementId, sectionId, variants:[...] }, ... ]
 *
 * Advanced (no inline markup needed): mutate existing elements by CSS selector via
 * per-variant `changes` ops instead of data-ab-variant divs:
 *   changes: {
 *     A: [],                            // control (no changes)
 *     B: [
 *       { selector: '.cta-button', text: 'Buy Now' },
 *       { selector: '.cta-button', addClass: 'cta--urgent' },
 *       { selector: '.cta-note', html: '<strong>Free shipping today</strong>' },
 *       { selector: '.cta-note', show: true },
 *       { selector: '.cta-secondary', hide: true },
 *       { selector: '.cta-button', attr: { 'aria-label': 'Buy now' }, style: { background: '#ff6b00' } }
 *     ]
 *   }
 * Change op keys: selector (required) + any of:
 *   text, html, attr {}, style {}, addClass, removeClass, show, hide
 *
 * Interaction tracking: add data-ab-track="click:element_name" to the relevant element
 * (it does not need to be inside a data-ab-section).
 */
window.AB_TEST_CONFIG = {
  options: {
    debug: false
  },
  tests: [
    {
      testId: 'example_product_cta',
      testName: 'Example - Product CTA copy',
      testType: 'classic_ab',
      pageType: 'product',
      variants: ['A', 'B'],
      variantWeights: [0.5, 0.5],
      match: {
        pageType: 'product',
        selector: '.product-form__buttons'
      },
      changes: {
        A: [],
        B: [
          { selector: '.product-form__buttons [type="submit"]', text: 'Buy It Now' },
          { selector: '.product-form__buttons [type="submit"]', addClass: 'aero-ab-cta--urgent' }
        ]
      }
    }
  ]
};
